import React from 'react';

import AuthButton from './AuthButton';
import queryString from './util/queryString';

interface ForceAdminOAuthProps {
  companyID: string;
  forcedMemberAuthMechanism?: string;
  removeBranding?: boolean;
  onFailure?: (error: any) => void;
  onSuccess?: (data: any) => void;
}

const ForceAdminOAuth: React.FC<ForceAdminOAuthProps> = ({
  companyID,
  forcedMemberAuthMechanism,
  removeBranding,
  onFailure,
  onSuccess,
}) => {
  let params;
  const loginCopy = {
    adminLinkText: removeBranding ? 'Log in with SSO' : 'Log in to Canny with SSO',
  };

  switch (forcedMemberAuthMechanism) {
    case 'oidc':
      params = {
        companyID,
        validateConfig: 'false',
      };
      return (
        <a
          href={`/api/oidc/initiate${queryString.stringify(params)}`}
          className="accountModalAdminLink">
          {loginCopy.adminLinkText}
        </a>
      );
    case 'azure':
      return (
        <div className="alternativeSignIn">
          <AuthButton
            authType="azure"
            onFailure={onFailure}
            onSuccess={onSuccess}
            value="Log in with Microsoft Entra ID"
          />
        </div>
      );
    default:
      return null;
  }
};

export default ForceAdminOAuth;
